var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16L1.376 11.8723C0.677793 10.6979 0.275862 9.32745 0.275862 7.86207C0.275862 3.52 3.79586 0 8.13793 0C12.48 0 16 3.52 16 7.86207C16 12.2041 12.48 15.7241 8.13793 15.7241C6.81683 15.7241 5.57269 15.3967 4.48 14.8212L0 16Z",
    fill: "#2CB742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.154 10.4787C12.791 9.79264 11.4522 9.00809 11.4522 9.00809C11.1493 8.8354 10.7838 8.81609 10.6111 9.12395C10.6111 9.12395 10.1761 9.64561 10.0655 9.72064C9.5601 10.063 9.09196 10.0497 8.61941 9.57719L7.5212 8.47899L6.423 7.38078C5.95045 6.90823 5.9372 6.44009 6.27955 5.93471C6.35458 5.82409 6.87624 5.38906 6.87624 5.38906C7.1841 5.21609 7.16479 4.85085 6.9921 4.54795C6.9921 4.54795 6.20755 3.20919 5.52148 2.84616C5.22962 2.69168 4.87127 2.74575 4.63789 2.97912L4.15293 3.46409C2.61445 5.00257 3.37196 6.7394 4.91045 8.27788L6.31651 9.68395L7.72258 11.09C9.26107 12.6285 10.9979 13.386 12.5364 11.8475L13.0213 11.3626C13.2547 11.1286 13.3085 10.7703 13.154 10.4787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.94fc62cf7c357be4f21429e61275c06d.svg";
export { ForwardRef as ReactComponent };